package devxertech.com.pages.blogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import devxertech.com.theme.toSitePalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img
import devxertech.com.utils.imageLoading
import org.w3c.dom.events.EventListener

@Composable
internal fun BlogImageSlot(
    url: String,
    fallbackUrl: String,
    alt: String,
    width: String = "100%",
    height: String,
    objectFit: String = "cover",
) {
    val palette = ColorMode.current.toSitePalette()
    var failed by remember(url) { mutableStateOf(false) }
    val src = if (url.isBlank() || failed) fallbackUrl else url
    Box(
        modifier = Modifier.fillMaxWidth().height(height.removeSuffix("px").toInt().px)
            .backgroundColor(palette.bodyBackgroundSecondary.rgb)
            .styleModifier { property("position", "relative"); property("overflow", "hidden") },
        contentAlignment = Alignment.Center
    ) {
        // Let the visible image own fetching and decoding so native lazy loading
        // can defer below-the-fold cards. No detached image or opacity gate.
        Img(src = src, attrs = Modifier.imageLoading(
            src, lazy = true,
            sizes = "(max-width: 767px) 84vw, (max-width: 1279px) 43vw, 22vw",
        ).toAttrs {
                attr("alt", alt)
                ref { element ->
                    val listener = EventListener { failed = true }
                    element.addEventListener("error", listener)
                    onDispose { element.removeEventListener("error", listener) }
                }
                attr("style", "display:block;width:$width;height:$height;object-fit:$objectFit;object-position:center;")
        })
    }
}

@Composable
internal fun BlogCardSkeleton() {
    val breakpoint = rememberBreakpoint()
    val palette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 100.percent else if (breakpoint <= Breakpoint.LG) 48.percent else 31.percent)
            .height(if (breakpoint >= Breakpoint.LG) 390.px else 396.px).borderRadius(12.px)
            .backgroundColor(palette.modalBackgroundColor.rgb)
            .styleModifier { property("overflow", "hidden"); property("box-shadow", "0 4px 19px rgba(0,0,0,.09)") }
    ) {
        Box(Modifier.fillMaxWidth().height(220.px).backgroundColor(palette.bodyBackgroundSecondary.rgb))
        Box(Modifier.fillMaxWidth().margin(top = 242.px).height(12.px).styleModifier {
            property("width", "35%"); property("margin-left", "20px"); property("background", "#e5e7eb"); property("border-radius", "4px")
        })
        Box(Modifier.fillMaxWidth().margin(top = 270.px).height(18.px).styleModifier {
            property("width", "78%"); property("margin-left", "20px"); property("background", "#e5e7eb"); property("border-radius", "4px")
        })
        Box(Modifier.fillMaxWidth().margin(top = 296.px).height(18.px).styleModifier {
            property("width", "56%"); property("margin-left", "20px"); property("background", "#e5e7eb"); property("border-radius", "4px")
        })
        Box(Modifier.fillMaxWidth().margin(top = 355.px).height(14.px).styleModifier {
            property("width", "28%"); property("margin-left", "20px"); property("background", "#e5e7eb"); property("border-radius", "4px")
        })
    }
}
